import LoadingSpinner from "../../loadingSpinner/LoadingSpinner";
import { Fingerprint } from "@mui/icons-material";
import useStyles from "../styles/styles";
import { Box } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import { ScannerInfo } from "../../../freya/scanSuccess/ScanSuccess";
import { useTranslation } from "react-i18next";
import { AlertWarning } from "../../../../common/styles/muiStyled";
import { useSelector } from "react-redux";
import { offlineSelector } from "../../../../redux/metadata/selectors/metadata.selectors";
import { eventEditionSelector } from "../../../../redux/eventEdition/selectors/eventEdition.selectors";
import User from "../../../../assets/User.svg";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";

type Props = {
  loading: boolean;
  photoUrl: string;
};

export const BadgePhoto = ({ loading, photoUrl }: Props) => {
  const { t } = useTranslation("common");
  const classes = useStyles();
  const { state } = useLocation();
  const { badgeInfo } = (state || {}) as ScannerInfo;
  const isOffline = useSelector(offlineSelector);
  const { eventEdition } = useSelector(eventEditionSelector);
  const isPhotoRequiredAndOffline = isOffline && !photoUrl && eventEdition.isPhotoRequiredForAccess;

  const getBadgeImage = () => {
    if (isPhotoRequiredAndOffline) {
      return (
        <Box data-testid="user-photo-wrapper" className={classes.userSvgWrapper}>
          <img src={User} alt={"badge-photo"} />
        </Box>
      );
    }
    return photoUrl ? (
      <img alt={"badge-photo"} src={photoUrl} className={classes.photoPlaceholder} />
    ) : (
      <Fingerprint data-testid="fingerprint-icon" className={classes.fingerprintIcon} />
    );
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {getBadgeImage()}
      <Box className={classes.scannedBadgeDesc}>{t("freya.scanYourQrCode.entrantName")}</Box>
      <Box className={classes.badgeOwner}>{badgeInfo?.contact ? `${badgeInfo.contact.firstName} ${badgeInfo.contact.lastName}` : ""}</Box>
      {isPhotoRequiredAndOffline && (
        <AlertWarning icon={<WarningRoundedIcon />} className={classes.noInternetMessage}>
          <Box data-testid="offline-message-box">
            <b>{t("freya.scanYourQrCode.noInternetPhoto.unableToLoad")}</b>{" "}
            {t("freya.scanYourQrCode.noInternetPhoto.deviceExperiencingIssues")}
          </Box>
        </AlertWarning>
      )}
    </>
  );
};
